import { Box } from '@chakra-ui/react';

import type { FooterProps } from './types/footer.props';

/**
 * Renders the footer section of the Slide Out component.
 *
 * @param controls - React nodes to be rendered as footer controls (e.g., buttons).
 * @param props - Additional props to be spread onto the footer container.
 * @returns The footer element containing the provided controls.
 */

export const Footer = ({ controls, onClose: _, ...props }: FooterProps) => {
  return <Box {...props}>{controls}</Box>;
};
